import { Unsubscribe } from '@/common/domain/Unsubscribe';
import { InjectionKey } from 'vue';

export const pageScrollBusKey: InjectionKey<PageScrollBus> = Symbol();

export interface PageScrollBus {
  scrolled(px: number): void;
  onScroll(scrolled: (px: number) => void): Unsubscribe;
}
